<div *ngIf="controller">
  <div class="stick-top">
    <mat-toolbar>
      <mat-icon>auto_transmission</mat-icon> {{!controller.id ? 'Create new Lock Controller' : ('Lock Controller: ' + controller.name)}}
    </mat-toolbar>
    <div class="hbox lightly-padded button-bar">
      <button mat-raised-button class="primary" type="button" (click)="save()" [disabled]="!form.form.valid">
        <mat-icon>{{!controller.id ? 'add' : 'save'}}</mat-icon>
        {{(controller.id ? 'Update ' : 'Add ')}}
      </button>
    </div>
  </div>

  <mat-tab-group>
    <mat-tab label="Settings">
      <div class="padded vbox-space">
        <div>
          <form #form="ngForm" role="form" class="vbox">
            <table class="simpleTable">
              <tr>
                <!-- controller -->
                <td class="align-top" style="width: 50%;">
                  <!-- controller config -->
                  <table class="basicTable vtable" style="width: 100%;">
                    <thead>
                    <tr>
                      <th colspan="100">Lock Controller Configuration</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="authService.hasRole('COMPANY_ADMIN')">
                      <th><micro-valid-label for="companyId" [model]="companyId" label="Company"></micro-valid-label></th>
                      <td>
                        <micro-company-select #companyId="ngModel"
                                              [(ngModel)]="controller.companyId"
                                              [required]="true"
                                              [disabled]="!authService.hasRole('SITE_LOCK_COMPANY') || (controller.id && controller.cabinetId) || controller.openAccessRequestCount > 0"
                                              id="companyId"
                                              name="companyId"
                        >

                        </micro-company-select>
                      </td>
                    </tr>
                    <tr *ngIf="!authService.hasRole('COMPANY_ADMIN')">
                      <th><micro-valid-label for="companyId2" [model]="companyId" label="Company"></micro-valid-label></th>
                      <td>
                        <micro-saHostCompany-select #companyId="ngModel"
                                                    [(ngModel)]="controller.companyId"
                                                    [required]="true"
                                                    id="companyId2"
                                                    name="companyId"
                                                    [includeHosted]="true"
                                                    [disabled]="!authService.hasRole('SITE_LOCK_COMPANY') || (controller.id && controller.cabinetId) || controller.openAccessRequestCount > 0"
                        >
                        </micro-saHostCompany-select>
                      </td>
                    </tr>
                    <tr>
                      <th><micro-valid-label for="name" [model]="name" label="Controller Name"></micro-valid-label></th>
                      <td>
                        <input #name="ngModel"
                               [(ngModel)]="controller.name"
                               required
                               placeholder="Name"
                               id="name"
                               name="name"
                               [disabled]="!authService.hasRole('SITE_LOCK_COMPANY') || controller.openAccessRequestCount > 0"
                        >
                      </td>
                    </tr>
                    <tr>
                      <th>Created</th>
                      <td>
                        {{controller.createdDate | dateTime}}
                      </td>
                    </tr>
                    <tr *ngIf="controllerOpenAccessRequestCount > 0 ">
                      <th [ngClass]="controllerOpenAccessRequestCount > 0 ? 'CRITICAL' : ''">Open Access Requests</th>
                      <td>
                        {{controllerOpenAccessRequestCount}}
                      </td>
                    </tr>
                    <tr>
                      <th colspan="99" style="text-align: center;">Controller Config/Details</th>
                    </tr>
                    <tr>
                      <th><micro-valid-label for="otpVersion" [model]="otpVersion" label="OTP Version"></micro-valid-label></th>
                      <td>
                        <select #otpVersion="ngModel"
                                [(ngModel)]="controller.otpVersion"
                                name="otpVersion"
                                id="otpVersion"
                                [required]="!disableSerial || !controller.id"
                                [disabled]="disableSerial || controller.id">
                          <option [value]="'v1'">V1</option>
                          <option [value]="'v2'">V2</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <th><micro-valid-label for="validityPeriod" [model]="validityPeriod" label="Validity Period (Hours)"></micro-valid-label></th>
                      <td>
                        <select #validityPeriod="ngModel"
                                [(ngModel)]="controller.validityPeriod"
                                name="validityPeriod"
                                id="validityPeriod"
                                required
                                [disabled]="!authService.hasRole('SITE_LOCK_COMPANY')">
                          <option [value]="2">2</option>
                          <option [value]="4">4</option>
                          <option [value]="6">6</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <th><micro-valid-label for="status" [model]="status" label="Status"></micro-valid-label></th>
                      <td>
                        <micro-saLock-status-select #status="ngModel"
                                                    [(ngModel)]="controller.status"
                                                    [required]="true"
                                                    [disabled]="!authService.hasRole('SITE_LOCK_COMPANY')"
                                                    id="status"
                                                    name="status"
                        >
                        </micro-saLock-status-select>
                      </td>
                    </tr>
                    <tr>
                      <th><micro-valid-label for="serialNumber" [model]="serialNumber" label="Serial Number"></micro-valid-label></th>
                      <td>
                        <input #serialNumber="ngModel"
                               [(ngModel)]="controller.serialNumber"
                               [required]="!disableSerial || !controller.id"
                               placeholder="Serial Number"
                               id="serialNumber"
                               name="serialNumber"
                               [disabled]="disableSerial || controller.id">
                      </td>
                    </tr>
                    <tr>
                      <th><micro-valid-label for="mac" [model]="mac" label="MAC Address"></micro-valid-label></th>
                      <td><input #mac="ngModel"
                                 [(ngModel)]="controller.mac"
                                 [required]="!controller.id"
                                 placeholder="MAC"
                                 id="mac"
                                 name="mac"
                                 [disabled]="!authService.hasRole('SITE_LOCK_COMPANY') || controller.id">
                      </td>
                    </tr>
                    <tr>
                      <th>Cabinet</th>
                      <td>
                        <micro-saCabinet-select [companyId]="controller.companyId"
                                                [(saCabinetId)]="controller.cabinetId"
                                                [required]="false"
                                                allLabel="Not set"
                                                [disabled]="!authService.hasRole('SITE_LOCK_CABINET') || !authService.hasRole('SITE_LOCK_COMPANY') || controller.openAccessRequestCount > 0">
                        </micro-saCabinet-select>
                      </td>
                    </tr>
                    <tr>
                      <th>Site</th>
                      <td>
                        <micro-site-select [companyId]="controller.companyId"
                                           [(siteId)]="controller.siteId"
                                           [pickList]="false"
                                           [required]="false"
                                           allLabel="Not set"
                                           [disabled]="!authService.hasRole('SITE_LOCK_SITE') || controller.cabinetId || !authService.hasRole('SITE_LOCK_COMPANY') || controller.openAccessRequestCount > 0">
                        </micro-site-select>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </td>
                <td class="align-top padded-left" style="width: 50%;">
                  <!-- controller firmware -->
                  <table class="basicTable vtable">
                    <thead>
                    <tr>
                      <th colspan="100">Lock Controller Firmware</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <th>Device Type</th>
                      <td><input [value]="controller.deviceType"
                                 placeholder="Taulock"
                                 [disabled]="true">
                      </td>
                    </tr>
                    <tr>
                      <th>Git Branch</th>
                      <td><input [value]="controller.gitBranch"
                                 placeholder="N/A"
                                 [disabled]="true">
                      </td>
                    </tr>
                    <tr>
                      <th>Git Revision</th>
                      <td><input [value]="controller.gitRevision"
                                 placeholder="N/A"
                                 [disabled]="true">
                      </td>
                    </tr>
                    <tr>
                      <th>Profile</th>
                      <td><input [value]="getFirmwareConfigObj(controller)?.profile"
                                 placeholder="N/A"
                                 [disabled]="true">
                      </td>
                    </tr>
                    <tr>
                      <th>MSISDN</th>
                      <td><input [value]="getFirmwareConfigObj(controller)?.alarmMsisdn"
                                 placeholder="N/A"
                                 [disabled]="true">
                      </td>
                    </tr>
                    <tr>
                      <th>Auto Reboot (min)</th>
                      <td><input [value]="getFirmwareConfigObj(controller)?.autoRebootMinutes"
                                 placeholder="0"
                                 [disabled]="true">
                      </td>
                    </tr>
                    <tr>
                      <th>Ethernet Enabled</th>
                      <td><input [value]="getFirmwareConfigObj(controller)?.ethernet ? 'YES' : 'NO'"
                                 placeholder="NO"
                                 [disabled]="true">
                      </td>
                    </tr>
                    <tr>
                      <th>rfIds</th>
                      <td>
                        <textarea style="min-height: 10px"
                                  [disabled]="true"
                                  [value]="getFirmwareConfigObj(controller)?.rfIds"
                                  cols="10"
                                  placeholder="None"
                                  rows="2">
                        </textarea>
                      </td>
                    </tr>
                    <tr>
                      <th>Raw Config</th>
                      <td>
                        <textarea style="min-width: 350px; min-height: 10px;"
                                  [disabled]="true"
                                  [value]="getFirmwareConfigObj(controller) | json"
                                  cols="10"
                                  placeholder="None"
                                  rows="3">
                        </textarea>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <!-- locks -->
                <td class="align-top padded-top" colspan="99">
                  <micro-saLockController-Locks
                    [controllerComponent]="this"
                    [locks]="controller.locks"
                    [defaultParamSetsByLockNumber]="defaultParamSetsByLockNumber"
                    [defaultParamSets]="defaultParamSets"
                    [controllerDeviceType]="controller.deviceType"
                  >
                  </micro-saLockController-Locks>
                </td>
              </tr>
            </table>
          </form>
        </div>
      </div>

<!--      <ng-container *ngIf="controller.cabinetId">-->
<!--        <micro-saCabinet-detail #saCabinetDetailComponent [saCabinetId]="controller.cabinetId" [disabled]="true"></micro-saCabinet-detail>-->
<!--      </ng-container>-->
    </mat-tab>
    <mat-tab *ngIf="controller.id" label="History">
      <ng-template matTabContent>
        <micro-audits objectType="SaLockController" [objectId]="controller.id"></micro-audits>
      </ng-template>
    </mat-tab>
  </mat-tab-group>

</div>
